// extracted by mini-css-extract-plugin
export default {"gitApiNext":"GitApiNext_gitApiNext__RPvN2","count":"GitApiNext_count__UBQCi","title":"GitApiNext_title__ZBSLS","link":"GitApiNext_link__XGLF-"};